import { render, staticRenderFns } from "./test-component-form.vue?vue&type=template&id=00c57068&"
import script from "./test-component-form.vue?vue&type=script&lang=js&"
export * from "./test-component-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports